import { getEndpoint } from "@api-routes/endpoint";
import { EADDRESS_TYPES } from "@constants";

const CONTACTS_MS_NAME = "contacts";
export const getContactDetailsRoute = (contactUuid: string) =>
    `${getEndpoint(CONTACTS_MS_NAME)}contacts/${contactUuid}`;

export const updateAddressRoute = (contactUuid: string) =>
    `${getEndpoint(CONTACTS_MS_NAME)}contacts/${contactUuid}/addresses`;

export const getContactAddressRoute = (addressType: EADDRESS_TYPES, contactUuid: string) =>
    `${getEndpoint(CONTACTS_MS_NAME)}contacts/${contactUuid}/addresses/${addressType}`;

export const getContactPermissionRoute = (permissionGroup: string, contactUuid: string) =>
    `${getEndpoint(CONTACTS_MS_NAME)}contacts/${contactUuid}/permissions?permissionGroupEnum=${permissionGroup}`;

export const updateContactPermissionRoute = (contactUuid: string) =>
    `${getEndpoint(CONTACTS_MS_NAME)}contacts/${contactUuid}/permissions`;

export const postContactAddressRoute = () => `${getEndpoint(CONTACTS_MS_NAME)}contacts`;
